import AuthApi from '@/services/api/auth-api'
import moment from 'moment';

const state = {
  profile: {}
};

const getters = {
  profile(state: { profile: any; }) {
    return state.profile;
  }
};

const actions = {
  FETCH_PROFILE(context: { commit: (arg0: string, arg1: any) => void; }) {
    return AuthApi.fetchProfile().then((response) => {
      //console.log("Resp::", response)
      response.created_at = moment(response.created_at).format('DD MMM YYYY')
      context.commit('SET_PROFILE', response);
    });
  },
};

const mutations = {
  SET_PROFILE(state: { profile: any }, payload: any) {
    state.profile = payload;
  }
};

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters
};
